// AUTO-GENERATED FILE - do not edit manually
// Generated by scripts/build_luxury_images_ts.py
// Source: scripts/image-cache/all_luxury_images.json
// 12 boutiques x 60 real luxury/prestige images each = 720 unique image URLs
// Images retrieved via ZAI image-search service (real luxury product photography).

export const luxuryImagesByBoutique: Record<string, string[]> = {
  'frais-marche': [
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f226217e7c42.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/718561969318.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/8a5fac486179.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b05fd3acf18d.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/9a39507e0953.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f4464b33fb21.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/5a4d1718f4af.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e11224c7223e.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/173040220b79.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/796d9d6ecfd2.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/356151c2728a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7c7e8b8752e3.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/89c387bea692.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c896a213221a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/5b1a51168787.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/bfe1731bd47e.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ae7eb90e6885.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/27bf53b74653.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2814c3eb9a83.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2ef446a6a993.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/eef55b73977d.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/17bc3df11037.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b868935b318a.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b9c3b916cf20.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/21b11d5608da.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/3636fc7e7f14.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/423deca7aff9.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d00727527144.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/04484cab58e8.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/4b4c3e861ec7.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e1db7a75d9c5.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/53526f8dde78.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/81732ec79572.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/cf098f1fc2bc.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6f021e19f590.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7cc9c49783d6.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/da3bbd3393af.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/63bda287d868.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/a90c713ffe27.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/19c1355343e1.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c7d064194a8a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/5b0b54c21d2c.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/75510000b1cf.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/61c8712b21af.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b2f633f841f2.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/a33299892778.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/9816df8e31d5.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/8007bc340547.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1ec817e70daa.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/76230ff59986.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7f15c91e4fd9.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c57cbedcc633.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1b2b3009df0b.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ab7772f996f2.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/966b74f0a523.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/4347c9d6a57e.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/52fe3907f127.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e4e90af245da.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/452406c54bd5.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/77760bbbd6e6.jpg',
  ],
  'epicerie-fine': [
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/accda71e8c2e.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/358272a291d5.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/4a105881da12.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/36cba58258b6.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/9f094a6a77ef.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/a867414ea005.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ac94bd51b3ff.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/602d950bb403.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/0bc05de999e1.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/bc38e7f1d445.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1d0567a6c812.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/566b01883ce8.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/5d96ddba29d3.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/cddfe194f8d0.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/8083836726a1.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1775f67dea58.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/aedfa457235b.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b5f98bb3cfe4.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6d7ab6e6a28e.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/65d265fefa4c.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/eff7b8edbef4.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/8600816288af.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/8220e3e23993.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/4eff49c5d040.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/70a16d02f6d6.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/49ab120f841d.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/af140daf25e4.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/cd34f563d11f.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/06d753f3854c.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/551620bf92b6.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/0b21cb3b7600.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d8bf59b2f6b7.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/45e099ef6ce9.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/052f7f9048d4.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/16e7f73ee761.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/723843830dfb.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/26c9f642b646.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d7932d1450bf.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/95086e9e0f9e.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/cfa0c363e483.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/878bac19d3e5.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/901d26bfef57.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/610e5b434796.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6e26867bb59c.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/186e6fca3787.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/13aba4890802.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/bc056edd39f1.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/cf23b634fd7e.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d730d350668e.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/4d49474a2ee5.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c11588b9678c.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/fb10fb3b90e2.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/bda4faafd94b.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/389b20fc5898.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/470ab00b1551.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b55a13fee99c.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/038b78141206.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/0c5a5e6142ae.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f99200d113e3.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/33cb97f9935f.jpg',
  ],
  'beaute-parfums': [
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1711c8ce31ac.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/83fcea478614.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/56ffbd11366c.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/14540dea2f34.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/8b9ace748731.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d76012833cfb.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/fc1b81742de1.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7f37082d9644.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/9febb427f0c9.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b7498210793d.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/04981897ad21.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/8eacc9cab690.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/0dd4bf604982.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e86ae51d2c92.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ea45f9163e18.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f0cf9c067c0b.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f55ea0944b0c.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/9e40fe70080b.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ddba38fca5ef.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2cffe0e83dbb.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/4563eeed118d.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7576fdd1b010.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/18b21a6bc3dc.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/caf0cd600640.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/91ac3248918a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1cc602bf1780.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/eeb1616a8a2a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/42f485d9d51e.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/61948b62a28c.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/a060101e8371.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/3ddc1586a292.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e57be7b324b4.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6f0ddf4d7bd3.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f0a76435b557.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2c8b249bc246.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/350ea94e280f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2201a676402a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/a5b6a89c17cc.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d63b2181407b.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6d45af3cf305.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/46ffd36bfb92.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7860e5dfdebd.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/4d900c6ed4c8.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/3909839816fa.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/09f50a9b677a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f771d7d684be.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d04e2f409506.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/eb2d9d8792c6.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/def0735a966b.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c798ce693b0f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/097c347187bc.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/49b79cd07147.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/39bbadc08338.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1dde438bbd38.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6df39a59008e.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f5b85827d021.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/008bf238090a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/9cea1ae089df.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/952170a9f7fa.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/5585a758ebc1.jpg',
  ],
  'hightech-electro': [
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/a0b441c7dd49.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/09e911a038d3.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/0f8072d25881.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6452d0ae2b2c.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/07ce8ffa2e32.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/220c3df4368a.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/13767a8aee7d.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e449c99a783f.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/306e85e436fa.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2b8c158d3e15.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6801caec4720.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d8687253c177.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/4b5a4d93a304.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/95bd040efc03.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/752805e8448c.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/fde571ee4fab.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/4d75051e0af9.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/222b0452c6da.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/9cd0c6163e48.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e942140a0755.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/9c7ef57f0056.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1f38fd054d4b.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/12ebe9e0e29d.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e4363d4ea233.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e6c18bf7ab37.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b7dd9e7f70a8.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/df1aa28809f5.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d3d0b09c8e09.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/068a5524a8c0.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/49e09fe42b1f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/5b4e52551391.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7fcac5086b3f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/fc1bf0cf116e.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/391dd87b16e1.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7ad4892f775f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b0f8fb27e207.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e15b7d34cb7f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/81d9b659ae9a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7659dcb1a711.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7c0de355054a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ab4e65fc13ee.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b70fe175e30a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/3cdd6dd4e9d6.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/19b4143f3808.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c3228d91cf85.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/719231dd2f65.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/3d24ea3401de.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/94d300919ee5.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c7ccbfd79060.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/849dad34831b.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/3c072918230e.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/03620c9ea57a.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/cadb376fe4db.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/a3863a6ccefb.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/61ffa9584414.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/0b6fd45498a6.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/43f49e1ddb56.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/390676634ab6.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/57d0330b82f0.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/a7faf5de08f2.jpeg',
  ],
  'mode-maison': [
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2e425e90880c.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ff9674c40f0a.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b0b66e4d560a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6abd51258c8a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/48df69844e3a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/704c90d781e1.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/fd6b3a86c1f0.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/9e2443916a13.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7d3cd372f2fb.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/8c7b82bee379.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/06acd3c84147.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/28a67522286a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/dff3903cf72f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/350af257f769.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/bcb7dd4625f6.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2439b3cd47f7.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/24532c92ec89.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/72efe2cce21f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/48d88ac30bd8.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e52963acb02b.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/8c48f8da4a38.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ef48a7920410.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b1f6dd8ed3c4.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/bcf317b6fed5.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/08da5328d68d.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/3b3937e07403.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/de2e6d1e67ea.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/144c98910378.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6d98e20204cc.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/78b68d08cc49.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/4bc88e554d03.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c8656796e194.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/bf71d8cc62d8.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/4c7fe62eedab.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/4268ad9bef23.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b9069e4ca3ec.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c32533cee5f0.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7ef5fdfccfa0.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1f9ca7dd5617.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/12e64e8d8039.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/946ef184934d.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c4d18196e130.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c7d67a5f29ea.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/5cf39cd9858e.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/4f07162db4b5.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/8e36f4dcd3ad.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/0b4e20dc4eb4.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/24160d398f72.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/251af565d534.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/441fa5a8570c.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/28d2057b22bd.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e19701dfbecb.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/3d63f6064412.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f73a7c959f76.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/3aeacb7c6910.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c5793dfff28e.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/3c3300736b6c.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/95e90cd6bc5d.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/cde0d621ba2e.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/067b25c8db57.jpg',
  ],
  'cave-exception': [
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/22424efd841b.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/5d1522bf2d74.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c269eb3e5f07.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/71e16bfd12d9.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/a3d7f55a151f.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/53c3a66a5937.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/dabda9187d06.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/54012f18d40f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/28a8652c5c02.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7a994c47cfff.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d4fd90e1ff46.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f24893417307.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2f55e255f048.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d8a3f8a1a770.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1245d17d72c7.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f6ce853b540a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ad2cddfc4e62.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b106450d948e.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/899688c07ac7.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/26108f4f060a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/db9209974666.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/46983e5fce1b.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e527bed147bf.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e2ecba615971.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ee55c0b18d01.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ad6bcadb0ef0.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/493be95c1e93.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/fe4c80b33199.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/92b13689f1ab.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f9841d20ab95.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/27067d864644.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c61e1c315b1d.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/3449264c5b97.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/4e0d6971e052.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e13f19cc40af.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e6c006313e30.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/8c821e1cbf0d.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/aaeb88977a1a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/82caeae50b53.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/23d37595f991.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/500d9baef455.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1cc21c40c987.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2269ef6dd7ad.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c6fe0b6267d7.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/68d22c45804f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/58ad167c041f.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2f05699d13d7.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d4660c232a7e.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2fdd9c0ac1f2.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/12255a3e21c5.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c688248f87ba.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b1d85d10ba5b.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/556ef2425f10.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/81414d72e365.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/980a9ad529c7.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/0ff3b35d1c0f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/03f89e47c2c6.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d977968cbf7b.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/cfac466b9dfb.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/0e6076725f03.jpg',
  ],
  'bazar-deco': [
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/07a1cb1072df.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b193089b26e3.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/8adb56449644.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/984199a89464.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/711ab60afa05.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6245ed448e2a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ec86a4def4f5.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/3aa94369cfa9.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1fc501346796.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c0facdf2cf70.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/491093ae2bcf.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/9a92f6e5bba0.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/8dc3fb20d4d5.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ea2a035a94e7.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/60fb606e2fc9.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/5eca314d69ca.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/654b8d82fbd3.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/14ddb19e6449.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/68122310fcef.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7ca2dd07dfa3.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d0dbc1d9bfb2.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/3c0bbdacd7ec.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1b1ceca714d1.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/efa135004b57.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/a25693a1e77d.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e8bc870e0f2b.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/a4eaabdf3675.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/eaededfc963c.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d2d15c7d8991.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/0a9c7130a050.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/9596a3138648.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d43597182910.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f27acb452449.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b5a3a833caf9.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/3a549f40cd35.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/14fc26892c0a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/890b5ac04389.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2de771a52cae.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/01053fe3c1d7.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6c3298897af0.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/82bf855b8d36.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/999d88d847a1.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/8a4d070f095d.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d2b6549f1eaa.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/5b7e6a725d2b.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2a8388746a42.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7ab759d08aa2.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c8e303511491.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/998bd8efbed1.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/5d2aa290079c.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/8c854ba14d6e.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/0b1876c11c91.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/cc10cb0e0f52.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/32a47b453d26.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f0f2f128afe9.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/bc6df83b8088.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e8e7ff891914.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b52fc681c9be.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/4062d8d195e3.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/72387a15a6f3.webp',
  ],
  'pharmacie': [
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/af03534903b3.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/44e76d9cbff9.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6174ba179644.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/fe8aec036f00.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/0ccd8065257a.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/4badfb38ec5b.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/84d6d280f3e2.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c2015348f18f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2c8b249bc246.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6110b0a77bcb.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1caf53990ea0.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ba3847d6b21a.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d7aa0646fbd1.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ff6ec0333ec8.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ae4972a8166b.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c10a63818a0a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b322dd3e4b35.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f55706c254a1.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/8d04a74dceaa.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c798ce693b0f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d9f695786635.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1d2695d7ac3f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/bcebeb0f7c34.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/53e905e43311.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/9f8ecaa7bb23.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/056de28fd0f0.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/83846b521d0a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f07f14989181.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/0304202a30b3.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/fa679dbce28b.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/4e4b4307cd18.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/a84ed86ee5a7.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d40610d1e75c.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/4bf30f12b888.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1bc0855ef0f4.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ea01546b7532.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b0dcc0ff0290.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c6da25e63033.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1473ec876367.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/434133b58bfc.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b36b0b7393f6.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/fbe99bd291ff.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/767e0e7f93f2.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/a7a1013fa133.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/11b288bca2f2.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/80ca224f9452.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d852b1e99753.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f184d2d8a95d.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/fec1bb2b9ebb.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2aabae582a37.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6a42471dbfd8.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f34da837d4f3.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/20eab0419f79.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/9372d2bdbb7c.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ac0c08507c37.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/0e26a2f5024f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/94445a7bc594.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/535379dfbb3e.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/bf9d0decc9d7.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/530ad11a7ce4.jpg',
  ],
  'boulangerie-royale': [
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1accc14e3305.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/0e99fa0c6575.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b58e937dc2d2.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c3519ea04289.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/8903f5e9a579.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b3d983a98ab5.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e9f9a02b9fe8.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e9639c8a5b6b.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/961587fe6034.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ca36c054826c.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/228ab104fe71.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/249ad7b49769.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/40c5816f4370.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/679305fb7219.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f829b806fc64.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/bccf3d69006b.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2c5120d5e713.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/cd0af15a7e9c.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1f1df45f1770.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/13117ca1d360.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e6ccd4bb5cd8.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/cfb19eacc3ee.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f8ab8c45463c.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/add620f5f70a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c63b15bb612d.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/61b9dd4ef6ce.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/4e36a37e8a1d.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/08066eb5f913.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ce64a92058fd.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/cc16aea57c74.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/34951fff855d.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ea5d094a272d.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/4ffdefbb500e.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/881f5bfb61de.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/dbd9cc9f1ff7.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/74afb0087fa3.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/455525801b21.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ea99798a8a4c.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2a0553b9af7e.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b13e567c7647.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e8f6157ab62e.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/5e59ea78246b.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7f5a9a665ff1.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/a2af5ea9724d.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d0670b0126a3.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/70755084deb0.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d287a3e371ed.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/9272ef6727c0.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/0e29e5d1bb3f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/00fb4ceb9ecf.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/a00de1448dc6.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e40d9e3d4dbf.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/015b52c06f2a.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/fa35c0e20bd2.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/450decf9f792.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/13853efb94e1.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c20b60b2ad31.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/039a168295c3.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6c3da787abef.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/42b8d3a243c3.jpg',
  ],
  'comptoir-cafes': [
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/fdaff3d6dd24.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/98971d3ae0f6.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/edb1f0c4d438.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1042f2a09a05.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f2b6253342f2.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/059fe216786f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ae29330f2365.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b35837d169d8.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/bde7e0bf673e.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c46996939eb5.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/a118a967f5a3.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/daaf5d6474a2.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/cebb2dd882b2.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/8128283ed301.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d2798a247482.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b28a3eb3e4f9.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/a76b9b05d8dc.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/efd021fbfdac.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/98250ad65914.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b7b340340e9c.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/235d355c37c0.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/75342dd2d35f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7e9334e54f19.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/359fa8f05346.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/9b42eec35dce.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2749e43e87fa.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c65995eaad9f.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/9a4cd96a3cb1.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1a7f2a071362.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/fc7a5e6e752e.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b1f95ec8a7d4.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/50436901d6b0.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d001c14fc03f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/161e4e269dac.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/767ee4577264.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6045489114dc.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/75589cdc47f1.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ff130c1c4b7f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b2dc0d27283d.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/0c36c6aeccab.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/0c0c81eb78b0.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6e115f067b98.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/43f417046d54.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d788e118349a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/fb07dd6956fd.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/be6db401fe6c.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/875cdb625cac.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b701344012c4.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/4ae9eacc4723.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/5ab2765af30d.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/956bbb49548b.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/aa2eccd7ef5f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6b5f053ffefe.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/bd2e4c679c8a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6a396991dad2.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f7b2e1fc363f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f3ac48ac67cc.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/36537879fd24.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/99dc08484323.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ab9aefc65530.jpg',
  ],
  'epicerie-monde': [
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/db4842a40925.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b1000362579e.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/359856ced85f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/044714c8c3f2.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/87839ab964fc.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f1b796491420.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/510a0356d037.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f9a469ea12b0.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7937dbc2f51e.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/a254288e5a5b.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/56e2646bd72d.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/a5d228801326.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1f5eea1599bc.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/834b2a581095.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/743097f517f7.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/13c8910c891a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/5247e702c76a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/8ac999be6fe7.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/cdb952ff27e9.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/376bfb42fd63.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/131e9e2f1927.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7eb4f779b148.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1ec2e6a63050.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/287e1e89f118.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d0574e5e99e6.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f9fd8248b6c1.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7be5096d0607.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/581986eb017c.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/098d7660faef.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/82ae84ad706d.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/3fe632faa4ad.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f2b65995cf0b.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6129548a4e3e.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/64e98ae95f31.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f33995207e10.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f6db876fa117.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/00fd503ce25d.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/98a521cb6f90.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/a0d16f27fbbf.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f7732637c8ec.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/10083c2cde18.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/26fe8ecdeb0c.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/fab4a808e24a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/5de8e2f58d05.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/62f577c777cf.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d81826af197f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d386771eb6f7.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/9d6899a26f84.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7a38abea2dce.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2f9abe703f6d.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6091cc938577.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/68cebc40dfd0.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/8281d7bdc34a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c0bf4f0755cf.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/fe56a21aac61.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/3f735be51da2.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/5b7e9054dc39.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/df892266b7d6.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/eb175d3313ac.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/fa41a9016e3d.jpg',
  ],
  'espace-enfant': [
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6db2e249cbca.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ee04030a3a54.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/dee63550ad54.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/c1088141cf13.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/b92d78d696bc.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6ea740ce1ae8.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d6c8b17f443a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/869e8d781cfe.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/091d4429bb45.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f2c6debe1802.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/9b73181e3550.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/513da3f20e84.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/21bb95f0b4f0.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6d142b09b0db.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1f8b075a8e50.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e2efc7286d3f.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/cbbabc411e12.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/0241a7c1967a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f815cd1d85ce.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f78f5ea227a6.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/6476ec006116.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/62976fa95a19.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2e1fdd0b8f24.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/4c1ac82a9717.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/5d135647787e.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/86273bac2441.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/38cff50f616d.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ae6385ca734a.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/ba1386ccd386.jpeg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/781d249350b1.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/dae3c84f47ec.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/459e86e86610.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/84708039f445.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/df540a7ae986.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e0057289bab0.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/9c37a8421e13.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d37f5d8de9cf.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2833cae4887d.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/57fab979aa7e.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e99203512c2b.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/329750df649f.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/9752aff23beb.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/a958c4ae5c14.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7176d654c436.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/0faaebeaecf3.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/e435fb803012.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/1c863e519a2a.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/81128b34d599.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/3f12b28d73e3.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/bdc98e6e6c2e.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/2d4f1f899e87.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/bf6db5d02c45.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/f01aed86b061.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/0d93825cc363.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/7eb567bbcbf6.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/292cdd6686e2.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/8625a13ecaaf.jpg',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/d1a74c6ca0ed.png',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/53585926d7c9.webp',
    'https://z-cdn.chatglm.cn/image-search-mcp/images-ppt/875beee3ee27.jpg',
  ],
};

export const TOTAL_LUXURY_IMAGES = 720;

/**
 * Get the luxury image URL for a given product.
 * Uses the product index within its boutique (0-49) to pick a unique image.
 */
export function getLuxuryImage(boutiqueId: string, productIndex: number): string {
  const pool = luxuryImagesByBoutique[boutiqueId];
  if (!pool || pool.length === 0) {
    return "https://picsum.photos/seed/" + boutiqueId + "/" + productIndex + "/400/500";
  }
  const idx = ((productIndex % pool.length) + pool.length) % pool.length;
  return pool[idx];
}
